import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { YouTubeUtils } from '../utils/youtube.utils';

/**
 * Validator function for YouTube URLs
 * @returns Validator function that validates YouTube URL format
 */
export function youtubeUrlValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        // Allow empty values (use required validator for mandatory fields)
        if (!value || value.trim() === '') {
            return null;
        }

        // Validate YouTube URL format
        if (!YouTubeUtils.isValidYouTubeUrl(value)) {
            return { invalidYouTubeUrl: { code: 'rfv10', value: value } };
        }

        return null;
    };
}
